import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/wealth',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-WealthLevel" */ '~/pages/WealthLevel')
    ),
  },
  {
    path: '/wealth/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WealthLevel-Rule" */ '~/pages/WealthLevel/Rule'
        )
    ),
  },
] as RouteConfig[]
